import React from 'react';
import styles from '../Operations.module.css';

interface BDGCComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const BDGC: BDGCComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
       More Badges = More Experts = More Sales. Within Ace Learning Place, there are 8 Product Knowledge Badges representing the key departments within the store. Each store needs 16 Product Knowledge Badges earned by customer-facing associates to achieve Pinnacle.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

       <div className={styles.sectionContent}>
       If a Product Knowledge Badge is earned in a previous year, as long as that associate it still employed with the store, the Badge will also count in the new year. 
      </div>
    
      <div className={styles.sectionTitle}>
        Drill Down
      </div>
      <div className={styles.sectionContent}>
        Clicking your score will open up a grid of active users for your store, their Badge completions, and each individual users Training Hours.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        See Ace Way of Retailing (AWOR){' '}
        <a
          href="https://acenet.aceservices.com/awor/helpful-customer-service/customer-first-culture"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          https://acenet.aceservices.com/awor/helpful-customer-service/customer-first-culture
        </a>{' '}
        or go to Ace Learning Place and search Helpful Ready for more information.
      </div>
    </div>
  );
};


BDGC.title = 'Product Knowledge Badges Earned';
BDGC.actionTitle = 'badges earned by associate';
BDGC.actionHyperlink = 'dynamicURL:WFC:current';
export default BDGC;

